module.exports = __webpack_public_path__ + "img/new_a2.1c25ab36.png";